(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chasen-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chasen-reviews')) {
    customElements.define('chasen-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.cards = [...this.querySelectorAll('[data-review]')];
        this.limit = Number(this.dataset.pageSize) || 5;
        this.rating = this.querySelector('select[data-rating]');
        this.photos = this.querySelector('[data-photos-only]');
        this.sort = this.querySelector('[data-sort]');
        this.list = this.querySelector('.cr__list');
        this.more = this.querySelector('[data-show-more]');
        const filters = this.querySelector('.cr__filters');
        this.querySelector('[data-toggle-filters]').addEventListener('click', e => {
          filters.hidden = !filters.hidden;
          e.currentTarget.setAttribute('aria-expanded', String(!filters.hidden));
        });
        [this.rating, this.photos, this.sort].forEach(el => el.addEventListener('change', () => { this.limit = Number(this.dataset.pageSize) || 5; this.update(); }));
        this.querySelectorAll('[data-rating-filter]').forEach(el => el.addEventListener('click', () => {
          this.rating.value = this.rating.value === el.dataset.ratingFilter ? 'all' : el.dataset.ratingFilter;
          this.limit = Number(this.dataset.pageSize) || 5;
          this.update();
        }));
        this.querySelector('[data-clear]').addEventListener('click', () => { this.rating.value = 'all'; this.photos.checked = false; this.limit = Number(this.dataset.pageSize) || 5; this.update(); });
        this.more.addEventListener('click', () => { this.limit += Number(this.dataset.pageSize) || 5; this.update(); });
        const reviewDialog = this.querySelector('[data-review-dialog]');
        this.querySelector('[data-write-review]').addEventListener('click', () => reviewDialog.showModal());
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
        });
        const photoDialog = this.querySelector('[data-photo-dialog]');
        this.querySelectorAll('[data-lightbox]').forEach(button => button.addEventListener('click', () => {
          const source = button.querySelector('img'), target = photoDialog.querySelector('img');
          target.src = source.currentSrc || source.src;
          if (source.srcset) target.srcset = source.srcset;
          target.sizes = '(max-width: 749px) 100vw, 65vw';
          target.alt = source.alt;
          const panel = photoDialog.querySelector('[data-photo-review]');
          panel.replaceChildren();
          const review = this.cards.find(card => card.id === button.dataset.reviewId);
          if (review) {
            for (const selector of ['.cr__reviewer','.cr__review-content']) {
              const original = review.querySelector(selector);
              if (original) {
                const copy = original.cloneNode(true);
                copy.querySelectorAll('.cr__inline-photo').forEach(el => el.remove());
                copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
                panel.append(copy);
              }
            }
          }
          panel.hidden = !review;
          photoDialog.showModal();
        }));
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-helpful]');
          if (!button) return;
          const pressed = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(pressed));
          button.querySelector('span').textContent = pressed ? '♥' : '♡';
        });
        if (this.querySelector('[data-form-success]') || reviewDialog.querySelector('.errors')) reviewDialog.showModal();
        this.update();
        this.setAttribute('data-ready', 'true');
        document.dispatchEvent(new CustomEvent('chasen:reviews-updated'));
      }
      disconnectedCallback() {
        document.dispatchEvent(new CustomEvent('chasen:reviews-updated'));
      }
      update() {
        const matches = this.cards.filter(card => (this.rating.value === 'all' || card.dataset.rating === this.rating.value) && (!this.photos.checked || card.dataset.photo === 'true'));
        matches.sort((a,b) => {
          const ar = Number(a.dataset.rating), br = Number(b.dataset.rating);
          if (this.sort.value !== 'newest') {
            if (!ar || !br) return (ar ? -1 : 0) + (br ? 1 : 0);
            return this.sort.value === 'highest' ? br-ar : ar-br;
          }
          return (Date.parse(b.dataset.date)||0)-(Date.parse(a.dataset.date)||0);
        });
        this.cards.forEach(card => card.hidden = true);
        matches.forEach((card,i) => { this.list.append(card); card.hidden = i >= this.limit; });
        this.querySelector('[data-visible-count]').textContent = matches.length;
        this.querySelector('[data-empty]').hidden = matches.length > 0;
        this.more.hidden = matches.length <= this.limit;
        this.querySelectorAll('[data-rating-filter]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.ratingFilter === this.rating.value)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
